import { FC, ReactNode } from "react";

export const KeyPairWrapper: FC<{ children: ReactNode; hide?: boolean }> = ({
  children,
  hide
}) => {
  if (hide) return null;

  return (
    <div className="grid w-full grid-cols-1 justify-between lg:grid-cols-2">
      {children}
    </div>
  );
};
